export default __webpack_public_path__ + "static/media/hht2_ep11_timeline_08.93ad8610.png";